import React, { useContext, useEffect, useState } from 'react';
import { fetchAffiliateLogs } from '../../http/userLogAPI';
import { Button, Table, Form } from 'react-bootstrap';
import { FaSyncAlt } from 'react-icons/fa';
import Loader from '../Loader';
import { Context } from '../../index';
import {check, resetPassword} from "../../http/userAPI";

const AllAffiliatesLog = ({ userId }) => {
    const { user } = useContext(Context);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        page: 1,
        limit: 1000,
        fromDate: '',
        toDate: '',
        minReward: 0,
    });

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await fetchAffiliateLogs(userId, filters); // 👈 правильно передаём
            const data = await check();
            user.setUser(data);
            setData(response.tree || []);
        } catch (error) {
            console.error('Failed to fetch affiliate logs:', error);
        } finally {
            setLoading(false);
        }
    };

    const resetFilters = () => {
        setFilters({
            page: 1,
            limit: 1000,
            fromDate: '',
            toDate: '',
            minReward: 0,
        });


    };

    useEffect(() => {
        fetchData();
    }, []);

    const flattenLogs = (tree) => {
        const all = [];
        const pushLogs = (logs, user, levelUp) => {
            logs.forEach((log) => all.push({ log, user, levelUp }));
        };

        tree.forEach((l1) => {
            pushLogs(l1.logs, l1.user, 1);
            l1.level2?.forEach((l2) => {
                pushLogs(l2.logs, l2.user, 2);
                l2.level3?.forEach((l3) => {
                    pushLogs(l3.logs, l3.user, 3);
                });
            });
        });

        return all;
    };

    const allLogs = flattenLogs(data);
    const sortedLogs = [...allLogs].sort(
        (a, b) => new Date(b.log.user_transaction_date) - new Date(a.log.user_transaction_date)
    );
    const totalRewards = sortedLogs.reduce(
        (sum, { log, levelUp }) => sum + (Number(log[`ref_level${levelUp}_reward`]) || 0),
        0
    );

    return (
        <div className="p-3 rounded">
            <div className="container-fluid">

                {/* Заголовок и бейджи */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
                    {/* Заголовок слева */}
                    <h6 className="text-success mb-0">Affiliate Reward Logs, List View</h6>

                    {/* Информация справа */}
                    <div className="d-flex flex-column flex-md-row text-md-end gap-1 gap-md-4">
                        <h6 className="text-muted small mb-0">
                            Current Reward Model: <strong>{user?.user?.affiliate_model === "OFF" ? "VIRT" : user?.user?.affiliate_model}</strong>
                        </h6>
                        <h6 className="text-muted small mb-0">
                            Affiliate Balance: <strong>${user.user.affiliate_balance?.toFixed(2)}</strong>
                        </h6>
                    </div>
                </div>



                {/* Фильтры и кнопки */}
                <div className="row g-2 justify-content-end mb-3">
                    <div className="col-6 col-sm-auto">
                        <Form.Label className="small text-muted mb-0">From Date</Form.Label>
                        <Form.Control
                            type="date"
                            size="sm"
                            className="text-success w-100"
                            value={filters.fromDate}
                            onChange={(e) => setFilters(prev => ({ ...prev, fromDate: e.target.value }))}
                        />
                    </div>

                    <div className="col-6 col-sm-auto">
                        <Form.Label className="small text-muted mb-0">To Date</Form.Label>
                        <Form.Control
                            type="date"
                            size="sm"
                            className="text-success w-100"
                            value={filters.toDate}
                            onChange={(e) => setFilters(prev => ({ ...prev, toDate: e.target.value }))}
                        />
                    </div>

                    <div className="col-6 col-sm-auto">
                        <div className="d-flex align-items-end h-100">
                            <Button variant="success" size="sm" onClick={fetchData}>
                                Apply Filters
                            </Button>
                        </div>
                    </div>

                    <div className="col-6 col-sm-auto">
                        <div className="d-flex align-items-end h-100">
                            <Button variant="outline-success" size="sm" onClick={resetFilters}>
                                Reset Filters
                            </Button>
                        </div>
                    </div>

                    <div className="col-12 col-sm-auto">
                        <div className="d-flex align-items-end h-100">
                            <Button variant="outline-success" size="sm" onClick={fetchData}>
                                <FaSyncAlt className="me-2" style={{ position: 'relative', top: '-2px' }} />
                                Refresh Data
                            </Button>
                        </div>
                    </div>
                </div>
            </div>



            {/* Таблица — адаптивная, с горизонтальным скроллом */}
            {loading ? (
                <Loader />
            ) : (
                <div className="table-responsive">
                    <Table striped bordered hover size="sm" className="w-100 small text-muted fst-italic mb-0" style={{ maxWidth: '98%', lineHeight: '14px' }}>
                        <thead>
                        <tr className="text-muted fst-italic small text-nowrap">
                            <th>Date</th>
                            <th>User</th>
                            <th>Level</th>
                            <th className="text-center">Plan</th>
                            <th className="text-center">%</th>
                            <th>Type</th>
                            <th>Description</th>
                            <th className="text-center">Amount</th>
                            <th className="text-center">Fee</th>
                            <th className="text-center">Net</th>
                            <th className="text-center">Reward</th>
                        </tr>
                        </thead>
                        <tbody>
                        {sortedLogs.map(({ log, user, levelUp }) => (
                            Number((log[`ref_level${levelUp}_reward`] ?? 0).toFixed(2)) === 0 ? null : (
                                <tr key={log.id} className="text-nowrap small">
                                    <td className="fst-italic text-muted">
                                        {(() => {
                                            const d = new Date(log.user_transaction_date);
                                            const day = String(d.getDate()).padStart(2, '0');
                                            const month = d.toLocaleString('en-US', { month: 'short' });
                                            const year = d.getFullYear();
                                            const hours = String(d.getHours()).padStart(2, '0');
                                            const mins = String(d.getMinutes()).padStart(2, '0');
                                            return `${day}-${month}-${year} ${hours}:${mins}`;
                                        })()}
                                    </td>
                                    <td className="text-center">{user.username}</td>
                                    <td className="text-center">{`L${levelUp}`}</td>
                                    <td className="text-center">{log[`reward_plan_type_levelUp${levelUp}`] || '-'}</td>
                                    <td className="text-center">{(log[`ref_level${levelUp}_percent`] ?? 0).toFixed(2)} %</td>
                                    <td>{log.user_transaction_type}</td>
                                    <td
                                        className="text-muted"
                                        style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: '250px'
                                        }}
                                    >
                                        {log.reward_description}
                                    </td>
                                    <td className="text-center">${log.total_amount?.toFixed(2)}</td>
                                    <td className="text-center">${log.stripe_fee?.toFixed(2)}</td>
                                    <td className="text-center">${log.net_amount?.toFixed(2)}</td>
                                    <td className="text-center">${(log[`ref_level${levelUp}_reward`] ?? 0).toFixed(2)}</td>
                                </tr>
                            )
                        ))}
                        </tbody>
                        <tfoot>
                        <tr className="small text-muted fw-bold text-nowrap">
                            <td className="text-start text-uppercase">Total Rewards:</td>
                            <td colSpan="9" className="text-end text-uppercase"></td>
                            <td className="text-success text-center">${totalRewards.toFixed(2)}</td>
                        </tr>
                        </tfoot>
                    </Table>
                </div>
            )}
        </div>
    );
};

export default AllAffiliatesLog;